module.exports = __webpack_public_path__ + "static/img/ikonaMikrofonDisabled-ON.e30d55bc.png";